var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16.001,
    viewBox: "0 0 17.5 16.001",
    width: 17.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.75 2.435h-9.739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.533 2.435h-2.783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.75 8.001h-2.783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.597 8.001h-9.847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.75 13.566h-9.729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.543 13.566h-2.793"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.597.75h3.371v3.371h-3.371z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.597 6.315h3.371v3.371h-3.371z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.543 11.88h3.371v3.371h-3.371z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9688d464ebc41d646bda43bf082b37ef.svg";
export { ForwardRef as ReactComponent };